export default "__VITE_ASSET__zc1QHbK5__"